// src/pages/layout/Sidebar.jsx
import { NavLink } from 'react-router-dom';
import {
  Home,
  UserPlus,
  Briefcase,
  Users,
  Clipboard,
  Bookmark,
  List,
  Bell,
  Monitor,
  X,
  FileText,
  BarChart2,
  PieChart,
  Database,
} from 'react-feather';
import logo from '../../assets/images/logo.png';
// import PerfectScrollbar from 'perfect-scrollbar';
import { useEffect, useRef, useState } from 'react';

export default function Sidebar({ isOpen, closeSidebar }) {
  const containerRef = useRef(null);
  const [roleId, setRoleId] = useState(null);

  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem('user'));
  //   if (user && user.role_id) {
  //     setRoleId(user.role_id);
  //   }

  //   let ps;
  //   if (containerRef.current) {
  //     ps = new PerfectScrollbar(containerRef.current, {
  //       wheelPropagation: false,
  //     });
  //     ps.update();
  //   }
  //   return () => {
  //     if (ps) ps.destroy();
  //   };
  // }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.role_id) {
      setRoleId(user.role_id);
    }
  }, []);

  const menuConfig = [
    {
      title: 'Main Menu',
      roles: [1, 2, 3, 5, 6, 7],
      items: [
        {
          name: 'Dashboard',
          path: '/Dashboard',
          icon: <Home size={20} />,
        },
      ],
    },
    {
      title: 'Manajemen & Users',
      roles: [5, 6, 1, 3],
      items: [
        {
          name: 'User Account',
          path: '/Users/List',
          icon: <UserPlus size={20} />,
        },
        // {
        //   name: "Group Kerja",
        //   path: "/Group/WorkGroup",
        //   icon: <Briefcase size={20} />,
        // },
        // {
        //   name: "Group Petugas",
        //   path: "#",
        //   icon: <Users size={20} />,
        // },
      ],
    },
    {
      title: 'Work & Order',
      roles: [1, 2, 4, 5, 6, 7, 3],
      items: [
        {
          name: 'Work Order',
          path: '/Wo/WorkOrder',
          icon: <Clipboard size={20} />,
        },
        {
          name: 'Penugasan',
          path: '/Wo/Penugasan',
          icon: <Bookmark size={20} />,
          roles: [4],
        },
      ],
    },
    {
      title: 'Laporan',
      roles: [2, 4, 5, 6, 3],
      items: [
        {
          name: 'Laporan Contact Center',
          path: '/Laporan/LaporanContactCenter',
          icon: <FileText size={20} />,
          roles: [2, 3, 5, 6],
        },
        {
          name: 'Laporan Handling Time',
          path: '/Laporan/LaporanHandlingTime',
          icon: <BarChart2 size={20} />,
          roles: [2, 3, 5, 6],
        },
        {
          name: 'Laporan Jenis Pengaduan',
          path: '/Laporan/LaporanJenisPengaduan',
          icon: <PieChart size={20} />,
          roles: [2, 3, 5, 6],
        },
        {
          name: 'Laporan Rekapitulasi',
          path: '/Laporan/LaporanRekapitulasi',
          icon: <Database size={20} />,
          roles: [2, 3, 5, 6],
        },
      ],
    },
  ];

  return (
    <div id="sidebar" className={isOpen ? 'active' : ''}>
      <div className="sidebar-wrapper active d-flex flex-column" style={{ height: '100vh' }}>
        <div className="sidebar-header">
          <img src={logo} alt="Logo" />
          <h3>PERUMDAM TKR</h3>
          <p>KABUPATEN TANGERANG</p>
          <button className="sidebar-toggler btn x" onClick={closeSidebar} onFocus={(e) => e.target.blur()}>
            <X size={20} />
          </button>
        </div>
        <div ref={containerRef} className="sidebar-menu flex-grow-1" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
          <ul className="menu">
            {menuConfig
              .filter((menu) => menu.roles.includes(roleId))
              .flatMap((menu, i) => [
                <li className="sidebar-title" key={`title-${i}`}>
                  {menu.title}
                </li>,
                ...menu.items
                  .filter((item) => !item.roles || item.roles.includes(roleId))
                  .map((item, j) => {
                    const key = `item-${i}-${j}`;

                    if (item.path.startsWith('/')) {
                      return (
                        <li className="sidebar-item" key={key}>
                          <NavLink
                            to={item.path}
                            className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
                          >
                            {item.icon}
                            <span>{item.name}</span>
                          </NavLink>
                        </li>
                      );
                    }

                    return (
                      <li className="sidebar-item" key={key}>
                        <a href={item.path} className="sidebar-link">
                          {item.icon}
                          <span>{item.name}</span>
                        </a>
                      </li>
                    );
                  }),
              ])}
          </ul>
        </div>
      </div>
    </div>
  );
}
